import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { References } from 'helpers/enums/referenceMenu';
import {
  AssessorRoutePath,
  AssociadoRoutePath,
  ListagemCadastrosPath,
  ParametrosRoutePath,
} from 'library/Routes';
import {
  AssembleiasIcon,
  HomeIcon,
  SettingsIcon,
  UserIcon,
} from 'plataforma-fundacao-componentes';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { IReducer } from 'store/Reducer';

import { leftMenuActionsClose } from 'store/modules/LeftMenuActions';

import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx } from 'helpers/utils/HTMLUtils';
import { assembleiasAssociadoActionsLoadAll } from 'store/modules/AssembleiasAssociadoActions';
import styles from './styles.module.scss';

interface MenuListProps {
  isAssociado?: boolean;
}

export function MenuList(props: MenuListProps) {
  const [subListReference, setSubListReference] = useState<References>(
    References.OPENED_ACTIVE
  );

  const history = useHistory();
  const location = useLocation();

  const dispatch = useDispatch();

  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);
  const { assembleias: assembleiasAssociado } = useSelector(
    (state: IReducer) => state
  );

  const assembleiaPathname = AssociadoRoutePath + '/assembleia';

  const isOpenedByReference = (reference: References) => {
    return reference === subListReference;
  };

  const setOpenedByReference = (reference: References) => {
    if (isOpenedByReference(reference)) {
      setSubListReference(References.FORCE_CLOSE);
    } else {
      setSubListReference(reference);
    }
  };

  const associadoPath = useMemo(() => {
    if (location.pathname === `${assembleiaPathname}/${currentEvent?.id}/`) {
      return true;
    }

    return false;
  }, [location.pathname, assembleiaPathname, currentEvent?.id]);

  const assessorPath = useCallback(
    (path: string) => {
      if (location.pathname === path) {
        return true;
      }

      return false;
    },
    [location.pathname]
  );

  useEffect(() => {
    if (props.isAssociado) {
      setOpenedByReference(References.ASSOCIADO_ASSEMBLEIAS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAssociado]);

  useEffect(() => {
    if (props.isAssociado && !assembleiasAssociado.all.length) {
      dispatch(assembleiasAssociadoActionsLoadAll(undefined, ErrorHandler));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAssociado, dispatch, location]);

  return !props.isAssociado
    ? [
        {
          id: 'assessor-menu-item-pagina-inicial',
          label: 'Início',
          icon: <HomeIcon />,
          active: assessorPath(AssessorRoutePath),
          onClick: () => {
            dispatch(leftMenuActionsClose());
            history.push(AssessorRoutePath);
          },
        },
        {
          id: 'assessor-menu-item-assembleias-governanca',
          label: 'Parâmetros',
          icon: <SettingsIcon />,
          active: assessorPath(ParametrosRoutePath),
          disabled:
            (usuario?.perfil.id === 'pertencer_consulta' &&
              !usuario?.perfil.assessorRoute.cadastros.ver &&
              currentEvent?.tipo !== 'REU') ||
            !usuario?.perfil.assessorRoute.cadastros.ver,
          onClick: () => {
            dispatch(leftMenuActionsClose());
            history.push(ParametrosRoutePath);
          },
        },
        {
          id: 'assessor-menu-item-assembleias-governanca',
          label: 'Associados cadastrados',
          icon: <UserIcon />,
          active: assessorPath(ListagemCadastrosPath),
          disabled:
            (usuario?.perfil.id === 'pertencer_consulta' &&
              !usuario?.perfil.assessorRoute.cadastros.ver &&
              currentEvent?.tipo !== 'REU') ||
            !usuario?.perfil.assessorRoute.cadastros.ver,
          onClick: () => {
            dispatch(leftMenuActionsClose());
            history.push(ListagemCadastrosPath);
          },
        },
      ]
    : [
        {
          id: 'associado-menu-item-pagina-inicial',
          label: 'Início',
          icon: <HomeIcon />,
          active: location.pathname === AssociadoRoutePath,
          onClick: () => {
            dispatch(leftMenuActionsClose());
            history.push(AssociadoRoutePath);
          },
        },
        {
          id: 'associado-menu-item-assembleias',
          label: 'Assembleias',
          icon: <AssembleiasIcon />,
          active: associadoPath,
          subListOpened: isOpenedByReference(References.ASSOCIADO_ASSEMBLEIAS),
          onClick: () => {
            setOpenedByReference(References.ASSOCIADO_ASSEMBLEIAS);
          },
          subList: assembleiasAssociado!?.all?.map((assembleia: any) => ({
            id: `associado-assembleia-${assembleia!?.idEvento!}`,
            label: assembleia!?.tituloEvento!,
            icon:
              location.pathname !==
                `${assembleiaPathname}/${assembleia!?.idEvento!}/` &&
              assembleia.situacaoOnlineEvento === AssembleiaStatus.Live ? (
                <div className={clsx([styles.sublist, styles.online])}>
                  <AssembleiasIcon />
                </div>
              ) : (
                <div className={styles.sublist}>
                  <AssembleiasIcon />
                </div>
              ),
            active:
              location.pathname ===
              `${assembleiaPathname}/${assembleia!?.idEvento!}/`,
            onClick: () => {
              dispatch(leftMenuActionsClose());
              history.push(`${assembleiaPathname}/${assembleia!?.idEvento!}/`);
            },
          })),
        },
      ];
}
